module.exports = __webpack_public_path__ + "static/media/MN.7cef8057.png";